import { useTranslation } from '../../i18n/LanguageContext'
import './Footer.css'

const Footer = ({ onAboutClick }) => {
  const { t } = useTranslation()
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <span className="footer__copyright">
            {t('footer.copyright')}
          </span>
          <button className="footer__about-btn" onClick={onAboutClick}>
            {t('footer.about')}
          </button>
        </div>
        <p className="footer__disclaimer">
          {t('footer.disclaimer')}
        </p>
      </div>
    </footer>
  )
}

export default Footer
